module.exports = __webpack_public_path__ + "static/media/Video_caption_2.f0eff1ec.png";